"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxAct = require("redux-act");

var _GlobalMessage = require("../types/GlobalMessage.types");

var _globalMessage = require("./globalMessage.actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  type: _GlobalMessage.MessageType.Info,
  variant: undefined,
  icon: '',
  isOpen: false,
  message: '',
  errorDetails: ''
};
exports.initialState = initialState;

var _default = (0, _reduxAct.createReducer)({}, initialState).on(_globalMessage.showGlobalMessage, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    type: payload.type || _GlobalMessage.MessageType.Info,
    variant: payload.variant || _GlobalMessage.MessageVariant.Snackbar,
    icon: payload.icon || '',
    isOpen: true,
    message: payload.text || 'Something went wrong!',
    errorDetails: payload.errorDetails || ''
  });
}).on(_globalMessage.hideGlobalMessageComponent, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isOpen: false
  });
}).on(_globalMessage.hideGlobalMessage, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    variant: undefined
  });
});

exports["default"] = _default;